'use client'

import useKeyboardShortcut, {
    HotKeysShortcut,
} from '@/hooks/useKeyboardShortcut'
import { signOutUser } from '@/lib/actions/auth.action'

const globalShortcuts: HotKeysShortcut[] = [
    {
        keys: ['alt', 'Q'],
        callback: signOutUser,
    },
]

const GlobalHotKeys = () => {
    useKeyboardShortcut({
        keys: globalShortcuts[0].keys,
        callback: globalShortcuts[0].callback,
    })

    return null
}

export default GlobalHotKeys
